import { FileTagsVisibility } from "@mapmycustomers/shared";
import Visibility from "@mapmycustomers/shared/enum/Visibility";

export const ALL_VISIBILITIES: FileTagsVisibility[] = [
  Visibility.SHARED_WITH_ORGANIZATION,
  Visibility.SHARED_WITH_TEAM,
  Visibility.PRIVATE,
];
